import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Slide } from "./slides/Slide";
import {
  getSlideIndexSynchronized,
  slideTypes
} from "../utils/slideHelpers";
import * as QueryString from "query-string";

export function DisplayChannel(props) {
  // Get the full pathname
  const location = window.location.pathname;
  
  // Split path into segments
  const segments = location.split("/").filter(segment => segment.length > 0);
  
  // Initialize variables
  let portal = null;
  let channelName = null;
  
  // Find portal ID (look for numeric segment that could be a portal)
  for (let i = 0; i < segments.length; i++) {
    const potentialPortal = parseInt(segments[i]);
    if (!isNaN(potentialPortal)) {
      portal = potentialPortal;
      
      // If we found a portal and there's a next segment, it might be the channel
      if (i + 1 < segments.length) {
        channelName = decodeURIComponent(segments[i + 1]);
      }
      break;
    }
  }
  
  // Apply special case mapping
  if (portal === 16 || portal === 25) {
    portal = 54;
  }

  const second = 1000; //as duration is set in seconds, we need to multiply by this to put in milliseconds for setTimeout. This can be lowered to make testing go faster.

  const [channel, setChannel] = useState({});

  const [currentSlide, setCurrentSlide] = useState(null);

  //this is only used to create an effect that happens once when channel and currentslide are loaded that won't repeat when currentslide is changed
  const [loaded, setLoaded] = useState(false);
  const [isManuallyPaused, setIsManuallyPaused] = useState(false);

  const handlePreviousSlide = (areaIndex) => {
    if (!channel || !channel.selectedSlides || !channel.selectedSlides[areaIndex] || !currentSlide || !currentSlide[areaIndex]) return;

    const currentAreaSlides = channel.selectedSlides[areaIndex].SlideIDs;
    if (currentAreaSlides.length <= 1) return; // No navigation if only one or no slides

    const currentSlideInArea = currentSlide[areaIndex];
    const currentIndex = currentSlideInArea.index !== undefined ? currentSlideInArea.index : currentAreaSlides.findIndex(s => s._id === currentSlideInArea._id);
    if (currentIndex === -1) return; // Should not happen if currentSlideInArea.index is maintained

    const prevIndex = (currentIndex - 1 + currentAreaSlides.length) % currentAreaSlides.length;
    const newSlide = { ...currentAreaSlides[prevIndex], index: prevIndex };

    setCurrentSlide(c => c.map((s, i) => (i === areaIndex ? newSlide : s)));
    setIsManuallyPaused(false); // Resume slideshow
  };

  const handleNextSlide = (areaIndex) => {
    if (!channel || !channel.selectedSlides || !channel.selectedSlides[areaIndex] || !currentSlide || !currentSlide[areaIndex]) return;

    const currentAreaSlides = channel.selectedSlides[areaIndex].SlideIDs;
    if (currentAreaSlides.length <= 1) return; // No navigation if only one or no slides

    const currentSlideInArea = currentSlide[areaIndex];
    const currentIndex = currentSlideInArea.index !== undefined ? currentSlideInArea.index : currentAreaSlides.findIndex(s => s._id === currentSlideInArea._id);
    if (currentIndex === -1) return;

    const nextIndex = (currentIndex + 1) % currentAreaSlides.length;
    const newSlide = { ...currentAreaSlides[nextIndex], index: nextIndex };

    setCurrentSlide(c => c.map((s, i) => (i === areaIndex ? newSlide : s)));
    setIsManuallyPaused(false); // Resume slideshow
  };

  let time = null;
  let lastUpdate = Date.now();

  //LOAD CHANNEL DATA and set up the starting slides
  const params = QueryString.parse(props.location.search);
  useEffect(() => {
    axios
      .post("/api/channels/getchannelfordisplay", {
        channel: { PortalId: portal, originalName: channelName },
        TestMode: params.TestMode === "true",
        browser: { UserAgent: window.navigator.userAgent },
      })
      .then((res) => {
        if (res.data.error) {
          console.log(`Error in getchannelfordisplay response: `);
          console.log(res.data.error);
          //alert(res.data.error);
        } else {
          const channelData = res.data;

          // Filter out invalid weather slides before setting state
          let slideFiltered = false;

if (channelData.selectedSlides) {
  channelData.selectedSlides = channelData.selectedSlides.map(areaGroup => {
    if (areaGroup.SlideIDs) {
      // Store the original length before filtering in this areaGroup
      const initialSlideCount = areaGroup.SlideIDs.length;

      areaGroup.SlideIDs = areaGroup.SlideIDs.filter(slide => {
        const isWeatherSlide = slide.type === slideTypes.weather.index;
        const hasWeatherData = slide.weather_url !== null;

        // Keep the slide if it's not a weather slide,
        // OR if it is a weather slide AND has data.
        const shouldKeep = !isWeatherSlide || hasWeatherData;

        // If a slide was filtered out for any reason, set the flag
        // slides should only be filtered out if there's an error that would indicate a need to refresh the page.
        if (!shouldKeep) {
          slideFiltered = true; // Set the flag because we are filtering this slide
        }

        return shouldKeep;
      });
    }
    return areaGroup;
  });

  // Also filter out areaGroups that now have no slides
  // This filter doesn't trigger the refresh timer itself, only the weather filter does.
  channelData.selectedSlides = channelData.selectedSlides.filter(areaGroup => areaGroup.SlideIDs && areaGroup.SlideIDs.length > 0);
}

// After all filtering is complete, check the flag
if (slideFiltered) {
  console.log("A slide was filtered out due to some kind of error. Scheduling page refresh in 1 minute.");
  // Set a timer to refresh the page after 1 minute (60,000 milliseconds)
  setTimeout(() => {
    console.log("Refreshing page now...");
    window.location.reload(); // Reload the current page
  }, 60000); // 60 seconds * 1000 ms/second
}

          //FOR TESTING/DEVELOPMENT PURPOSES - FILTER SLIDES BY TYPE
          /*
        res.data.selectedSlides = res.data.selectedSlides.map((item) => {
          if (item.SlideIDs)
            item.SlideIDs = item.SlideIDs.filter(
              (slide) => slide.type == slideTypes.rte.index
            );
          return item;
        });*/

          setChannel(channelData); // Use the filtered data
          let currentSlides = [];
          // Initialize currentSlides based on the *filtered* data
          if (channelData.selectedSlides) {
              channelData.selectedSlides.forEach((area, index) => {
                // Ensure the area still has slides after filtering
                if (area.SlideIDs && area.SlideIDs.length > 0) {
                    let slide = area.SlideIDs[0]; 
                    slide.index = 0;
                    currentSlides.push(slide);
                } else {
                    // Handle cases where an area might become empty after filtering
                    currentSlides.push(null); // Or however empty areas should be represented
                }
              });
          }
          setCurrentSlide(currentSlides);

          setLoaded(true);
        }
      })
      .catch((err) => {
        console.log(`Error processing getchannelfordisplay response:`);
        console.log(err);
        //alert(err);
      });
  }, [portal, channelName, props.location.search, params.TestMode]);

  // Effect for handling manual pause/play input
  useEffect(() => {
    if (channel.allowManualControl) {
      const handleKeyDown = (event) => {
        if (event.key.toLowerCase() === 'p') {
          setIsManuallyPaused(prev => !prev);
        } else {
          // Any other key press while manual control is active pauses the slideshow
          setIsManuallyPaused(true);
        }
      };

      const handleMouseDown = () => {
        setIsManuallyPaused(true);
      };


      window.addEventListener('keydown', handleKeyDown);
      window.addEventListener('mousedown', handleMouseDown);

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        window.removeEventListener('mousedown', handleMouseDown);
      };
    } else {
      // If manual control is disabled or channel not loaded, ensure slideshow is not paused by this mechanism
      setIsManuallyPaused(false);
    }
  }, [channel, channel.allowManualControl]); // Dependencies

  const switchSlides = useCallback(
    (areaIndex, slideIndex) => {
      if (isManuallyPaused) return; // Don't switch slides if manually paused
      //we may want to re-sync with the server at some point
      if (!time) {
        axios.get("/serverTime").then((res) => {
          time = res.data;
          console.log(`Got server time: ${time}`);
          setTimeout(() => switchSlides(areaIndex, 0), 100);
        });
      } else {
        let selectedSlides = channel.selectedSlides[areaIndex];
        if (selectedSlides === undefined) return;
        //let currentSlide = selectedSlides.SlideIDs[slideIndex];

        //get the next slide in this area.
        let nextSlideIndex = getSlideIndexSynchronized(
          channel,
          areaIndex,
          time
        );
        let nextSlide = selectedSlides.SlideIDs[nextSlideIndex];
        nextSlide.index = nextSlideIndex;

        //replace the old slide in this area with the new slide
        if (nextSlideIndex !== slideIndex)
          setCurrentSlide((c) =>
            c.map((item, idx) => {
              if (idx === areaIndex) {
                return nextSlide;
              } else return item;
            })
          );

        //let duration = nextSlide.duration * second;
        //setTimeout(() => switchSlides(areaIndex, nextSlideIndex), duration);

        //if the number of milliseconds since midnight on January 1, 1970, UTC is exactly divisible by 100, wait 100 ms, otherwise, add time to try to get it to a multiple of 100.
        //this is to ensure the switchSlides function happens at the same time across all players that are synced to the same time.
        let timeout = time % 100 === 0 ? 100 : 100 + (time % 100);

        //use difference in local time since this ran last to add to the time received from the server.
        var now = Date.now();
        var dt = now - lastUpdate;
        lastUpdate = now;

        time += dt;

        //console.log(`Time is ${time}.`);
        setTimeout(() => switchSlides(areaIndex, nextSlideIndex), timeout);
      }
    },
    [channel, isManuallyPaused] // Added isManuallyPaused to dependencies
  );

  //once loaded, start switching slides in each area.
  useEffect(() => {
    // Start/resume slide switching only if loaded, channel has slides, and not manually paused
    if (loaded && channel.selectedSlides && !isManuallyPaused) {
      channel.selectedSlides.forEach((item, idx) => {
        //make sure there's actually a slide in the area, and another to switch to.
        if (item.SlideIDs.length > 1) {
          switchSlides(idx, 0);
        }
      });
    }
  }, [loaded, channel, switchSlides, isManuallyPaused]); // Added isManuallyPaused

  useEffect(() => {
    if (!channel.disableAutoRefresh && loaded) {
      //default 1 hour refresh
      let duration = (channel.refreshFrequencyMinutes || 60) * 60 * 1000;
      console.log("Setting auto refresh timer..." + duration);

      setInterval(() => {
        //check this route to ensure internet connection
        axios
          .post("/api/channels/getforcedrefresh", {
            PortalId: portal,
            originalName: channelName,
          })
          .then((res) => {
            if (res.data !== undefined) {
              document.location.reload();
            }
          })
          .catch(() => console.log("internet connection issue."));
      }, duration);
    }
  }, [loaded, channel.disableAutoRefresh, channel.refreshFrequencyMinutes]);

  useEffect(() => {
    console.log("Manual refresh timer effect.");
    const checkForcedRefresh = () => {
      axios
        .post("/api/channels/getforcedrefresh", {
          PortalId: portal,
          originalName: channelName,
        })
        .then((res) => {
          if (res.data === true) {
            document.location.reload();
          }
        });
    };
    if (!channel.disableForceRefreshCheck && params.TestMode !== "true") {
      //default 2 minute force refresh
      let duration =
        (channel.forcedRefreshCheckFrequencyMinutes || 2) * 60 * 1000;
      console.log("Setting check manual refresh timer..." + duration);
      setInterval(() => checkForcedRefresh(), duration);
    }
  }, [
    channel.disableForceRefreshCheck,
    channel.forcedRefreshCheckFrequencyMinutes,
    channelName,
    portal,
    params.TestMode,
  ]);

  if (channel.responsive) {
    channel.width = Math.min(channel.width, 100);
    channel.height = Math.min(channel.height, 100);
  }
  return (
    <div
      className="channel"
      style={{
        backgroundImage: `url('${channel.backgroundimage}')`,
        width: channel.width
          ? `${channel.width}${channel.responsive ? "%" : "px"}`
          : "100%",
        height: channel.height
          ? `${channel.height}${channel.responsive ? "%" : "px"}`
          : "100%",
        overflow: "hidden",
        position: "absolute",
        cursor: channel.allowManualControl ? "default" : (window.location.href.includes("localhost") ? "auto" : "none"),
        backgroundSize: channel.responsive ? "100% 100%" : "auto",
      }}
    >
      {channel.selectedSlides
        ? channel.selectedSlides.map((item, idxArea) => {
            //if a new area has no slides it won't be in the selectedSlides array so the area won't display. Not sure if that could make any meaningful difference though...
            const area = item.AreaID;
            if (item.SlideIDs.length === 0) return null;
            if (area) {
              const areaStyles = {
                position: "absolute",
                left: area.responsive ? `${area.x}%` : area.x,
                top: area.responsive ? `${area.y}%` : area.y,
                width: area.responsive
                  ? area.widthResponsive
                    ? area.widthResponsive
                    : `${area.width}%`
                  : area.width,
                height: area.responsive
                  ? area.heightResponsive
                    ? area.heightResponsive
                    : `${area.height}%`
                  : area.height,
                backgroundColor: area.backgroundColour,
                zIndex: area.z,
                overflow: "hidden",
              };

              return (
                <div className="area" key={idxArea} style={{...areaStyles}}> {/* Ensure area is a positioning context for arrows */}
                  <div style={{position: 'relative', height: '100%'}}> {/* Navigation Arrows for the Area */}
                  {channel.allowManualControl && item.SlideIDs.length > 1 && (
                    <>
                      <button 
                        onClick={() => handlePreviousSlide(idxArea)} 
                        style={{
                          position: 'absolute',
                          left: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          zIndex: 100, // Ensure arrows are on top
                          background: 'rgba(0,0,0,0.5)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '40px',
                          height: '40px',
                          fontSize: '20px',
                          cursor: 'pointer',
                        }}
                      >
                        &#x2190; {/* Left Arrow Unicode */}
                      </button>
                      <button 
                        onClick={() => handleNextSlide(idxArea)} 
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          zIndex: 100,
                          background: 'rgba(0,0,0,0.5)',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '40px',
                          height: '40px',
                          fontSize: '20px',
                          cursor: 'pointer',
                        }}
                      >
                        &#x2192; {/* Right Arrow Unicode */}
                      </button>
                    </>
                  )}
                  {item.SlideIDs.map((item, idxSlide) => {
                    const now = new Date();
                    const start = new Date(item.scheduleStart);
                    const end = new Date(item.scheduleEnd);
                    let show = false;
                    if (item.alwaysDisplay) show = true;
                    if (item.alwaysDisplayAfterStartDate && now >= start)
                      show = true;
                    if (now >= start && now <= end) show = true;

                    return show ? (
                      <Slide
                        key={idxSlide}
                        slide={item}
                        area={area}
                        areaIndex={idxArea}
                        slideIndex={idxSlide}
                        channel={channel}
                        currentSlide={currentSlide}
                        preview={false}
                        isManuallyPaused={isManuallyPaused}
                        manualControlActive={channel.allowManualControl || false}
                      ></Slide>
                    ) : null;
                  })}
                  </div>
                </div>
              );
            } else return null;
          })
        : "Loading content..."}
    </div>
  );
}
